import { createRoutableExtension } from '@backstage/core-plugin-api';
import { catalogEntityCreatePermission } from '@backstage/plugin-catalog-common/alpha';
import {
  CatalogImportPage,
  catalogImportPlugin,
} from '@backstage/plugin-catalog-import';
import { RequirePermission } from '@backstage/plugin-permission-react';

const GatedImportPage = () => (
  <RequirePermission permission={catalogEntityCreatePermission}>
    <CatalogImportPage />
  </RequirePermission>
);

/**
 * The upstream catalog import page, shown only to users who may create catalog
 * entities. Users without catalogEntityCreatePermission see the not-found page.
 *
 * The permission check cannot move inside the upstream CatalogImportPage, so
 * this is a routable extension of the catalog-import plugin on the same mount
 * point. The element App.tsx mounts at /catalog-import therefore carries the
 * catalog-import plugin and its importPage route ref itself. The New Frontend
 * System route collector reads both from the route's direct element only, and
 * without them it would detach the page from its plugin, its API and the
 * route bindings that point at it (PRD #22 §6.3).
 */
export const GatedCatalogImportPage = catalogImportPlugin.provide(
  createRoutableExtension({
    name: 'GatedCatalogImportPage',
    component: () => Promise.resolve(GatedImportPage),
    mountPoint: catalogImportPlugin.routes.importPage,
  }),
);
